function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
import { getApiEnv, getUrlParmas, json2formdata } from "../utils";
import { delCookie, getCookie, setCookie } from "../utils/cookie";
import { ACCESS_TOKEN, ACTIVITY_COUNT_EXPIRES, ACTIVITY_STOCK_COUNT, APPID, REFRESH_TOKEN, WX_TYPE, WX_USER_DATA } from "../utils/keys";
import LStorage from "../utils/lStorage";
import { LoginByOtherType, loginAndBind, loginByCode, queryCountrycodeList, sendMessageWithCaptcha, sendMessageWithSign, servicePushWhenSendSms, switchWxStatus } from "./api";
// @ts-ignore
import hmacSha256 from 'crypto-js/hmac-sha256';
// @ts-ignore
import encBase64 from 'crypto-js/enc-base64';
import { getSourceInfo } from "./sourceinfo";
import { getGDSSID, getWexinUserInfoByOpenid } from "./tokenless";
import qs from 'query-string';
import { setUserLoginInfo } from "./userInfo";
import checkToken from "./token";
import { sensorsLogin } from "./sensors";
import Captcha from "../utils/captcha";
import { getCustomArgs } from "./CustomArgsService";

/**
 * 获取国家对应code列表
 */
export var getCountryCodeList = function getCountryCodeList() {
  return new Promise(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
      var res, list;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return queryCountrycodeList({
              hasMainland: true
            });
          case 2:
            res = _context.sent;
            if (!res.status) {
              list = res.result.map(function (item) {
                return {
                  label: item.country_name,
                  value: item.country_code
                };
              });
              resolve(list);
            } else {
              resolve([]);
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

/**
 * 获取短信签名密钥
 * @returns 签名密钥
 */
export var getSmsSignSecret = function getSmsSignSecret() {
  // 密钥与APPID对应
  // 正式：c8f4252cbb294882c4d0e6815f69efde
  // pre：7e4a0ef71b0db1cf8440d0f6b863cb7a
  // 测试：6c4bd51b9e4020c28b9d1f03f8f94bb9
  switch (getApiEnv()) {
    case 't-':
      return '6c4bd51b9e4020c28b9d1f03f8f94bb9';
    case 'pre-':
      return '7e4a0ef71b0db1cf8440d0f6b863cb7a';
    default:
      return 'c8f4252cbb294882c4d0e6815f69efde';
  }
};

/**
 * 打开滑块验证
 * @returns 滑块验证结果
 */
export var captchaByTencent = function captchaByTencent() {
  return new Promise(function (resolve, reject) {
    try {
      var _Captcha;
      (_Captcha = new Captcha({
        onCaptchaSuccess: function onCaptchaSuccess(res) {
          resolve(res);
        }
      })) === null || _Captcha === void 0 ? void 0 : _Captcha.showCaptcha();
    } catch (error) {
      reject(error);
    }
  });
};

/**
 * 生成uuid
 */
export var getUuid = function getUuid() {
  var d = new Date().getTime();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now();
  }
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
};

/**
 * 发送验证码经过滑块验证
 * @param baseArgs 基础参数
 * @returns 发送方法
 */
export var sendVerifyCodeWithCaptcha = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(baseArgs) {
    var _cap, params;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return captchaByTencent();
        case 2:
          _cap = _context2.sent;
          if (!(!_cap || _cap.errorCode === 1001)) {
            _context2.next = 5;
            break;
          }
          throw '验证异常，请稍后再试';
        case 5:
          params = _objectSpread(_objectSpread({}, baseArgs), {}, {
            clientType: 'h5',
            version: 'v2',
            ticketRandStr: (_cap === null || _cap === void 0 ? void 0 : _cap.randstr) || '',
            ticket: (_cap === null || _cap === void 0 ? void 0 : _cap.ticket) || ''
          });
          return _context2.abrupt("return", sendMessageWithCaptcha(params));
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function sendVerifyCodeWithCaptcha(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * 发送验证码经过签名
 * @param baseArgs 基础参数
 * @returns 发送方法
 */
export var sendVerifyCodeWithSign = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(baseArgs) {
    var secret, extendArgs;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          secret = getSmsSignSecret(); // 签名密钥
          extendArgs = {
            appId: APPID,
            timestamp: Date.now(),
            uuid: getUuid(),
            sign: ''
          };
          extendArgs.sign = encBase64.stringify(hmacSha256(extendArgs.timestamp + extendArgs.uuid, secret));
          return _context3.abrupt("return", sendMessageWithSign(baseArgs, extendArgs));
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function sendVerifyCodeWithSign(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * 发送验证码
 * @param phone 手机号
 * @param areaCode 区号
 */
export var sendVerifyCode = function sendVerifyCode(phone, areaCode, where) {
  return new Promise(/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(resolve, reject) {
      var GDSSID, PHPSESSID, isChinaPhoneNum, phoneNum, params, _qs$parseUrl, url, query, searchUrl, _yield, status, info, _searchUrl, sourceType, mcrmActivityTypeStr, x_field_1;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getGDSSID();
          case 2:
            GDSSID = _context4.sent;
            PHPSESSID = getCookie('PHPSESSID') || GDSSID;
            isChinaPhoneNum = areaCode === '86'; // 是否为国内手机号
            phoneNum = isChinaPhoneNum ? phone : areaCode + phone;
            params = {
              phone: phoneNum,
              sessionId: PHPSESSID,
              languageType: 'CH',
              source: APPID,
              tpl: isChinaPhoneNum ? '' : 'SMS_171115471'
            }; // 若是mcrm来源
            _qs$parseUrl = qs.parseUrl(window.location.href), url = _qs$parseUrl.url, query = _qs$parseUrl.query;
            searchUrl = qs.parse(window.location.search);
            searchUrl = getUrlParmas(searchUrl);
            if (searchUrl && searchUrl.sourceType === 'mcrm') {
              params.tpl = isChinaPhoneNum ? 'SMS_225800021' : 'SMS_225381811';
              params.label = '校园向上吧';
            }
            // 国际号使用滑块验证后发送验证码
            _context4.prev = 11;
            _context4.next = 14;
            return (!isChinaPhoneNum ? sendVerifyCodeWithCaptcha : sendVerifyCodeWithSign)(params);
          case 14:
            _yield = _context4.sent;
            status = _yield.status;
            info = _yield.info;
            if (!status) {
              searchUrl = where ? Object.assign(searchUrl, where) : searchUrl;
              _searchUrl = searchUrl, sourceType = _searchUrl.sourceType, mcrmActivityTypeStr = _searchUrl.mcrmActivityTypeStr, x_field_1 = _searchUrl.x_field_1;
              if (!query['salesman']) {
                servicePushWhenSendSms(_objectSpread(_objectSpread({
                  phone: phoneNum,
                  platform: 'h5',
                  xfield: x_field_1,
                  sourceUrl: qs.stringifyUrl({
                    url: url,
                    query: _objectSpread(_objectSpread({}, getCustomArgs()), query)
                  })
                }, where), {}, {
                  sourceType: sourceType ? sourceType : undefined,
                  mcrmActivityTypeStr: mcrmActivityTypeStr ? mcrmActivityTypeStr : undefined
                }));
              }
              resolve('发送成功');
            } else {
              reject(info);
            }
            _context4.next = 23;
            break;
          case 20:
            _context4.prev = 20;
            _context4.t0 = _context4["catch"](11);
            reject('发送失败，请稍后再试');
          case 23:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[11, 20]]);
    }));
    return function (_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }());
};

/**
 * 退出登录
 * @param clearAutherize 是否清理微信授权信息 default: true
 */
export var logout = function logout() {
  var _window;
  var clearAutherize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  delCookie(ACCESS_TOKEN);
  delCookie(REFRESH_TOKEN);
  var activity_stock_count = LStorage.get(ACTIVITY_STOCK_COUNT);
  var activity_count_expires = LStorage.get(ACTIVITY_COUNT_EXPIRES);
  LStorage.clear();
  if (activity_stock_count) LStorage.set(ACTIVITY_STOCK_COUNT, activity_stock_count);
  if (activity_count_expires) LStorage.set(ACTIVITY_COUNT_EXPIRES, activity_count_expires);
  if ((_window = window['browser']) !== null && _window !== void 0 && _window.iswx) {
    if (clearAutherize) {
      delCookie(WX_USER_DATA);
    } else {
      var wxUserInfo = getCookie(WX_USER_DATA);
      wxUserInfo['UserId'] = 0;
      setCookie(WX_USER_DATA, wxUserInfo);
    }
  }
};

/**
 * 获取用户微信授权信息
 * @param data 登录返回信息
 */
export var getCurrentWeappWxData = function getCurrentWeappWxData(userData, weappId) {
  if (!userData) {
    return null;
  }
  var UserWxExtend = userData.UserWxExtend;
  // 微信信息存在且不为0
  if (UserWxExtend && UserWxExtend.length) {
    // 轮询用户多微信用户信息
    for (var i = 0; i < UserWxExtend.length; i++) {
      // 与当前小程序匹配
      if (UserWxExtend[i].WxAppId === weappId) {
        return UserWxExtend[i];
      }
    }
  }
  return null;
};

/**
 * 通过openid登录
 * @param openid
 * @param force true 为强制授权 不传或者 false 则为静默授权 若是强制授权将会获取userinfo更新到中台
 */
export var loginByWexinOpenid = function loginByWexinOpenid(openid) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Promise(/*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(resolve, reject) {
      var GDSSID, PHPSESSID, sourceInfo, wxUserInfo, params, data, status, result, info, currentWxUserInfo;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return getGDSSID();
          case 2:
            GDSSID = _context5.sent;
            PHPSESSID = getCookie('PHPSESSID') || GDSSID;
            _context5.next = 6;
            return getSourceInfo();
          case 6:
            sourceInfo = _context5.sent;
            if (!force) {
              _context5.next = 17;
              break;
            }
            _context5.prev = 8;
            _context5.next = 11;
            return getWexinUserInfoByOpenid(openid);
          case 11:
            wxUserInfo = _context5.sent;
            _context5.next = 17;
            break;
          case 14:
            _context5.prev = 14;
            _context5.t0 = _context5["catch"](8);
            console.log(_context5.t0);
          case 17:
            params = {
              loginType: 'SCRM_AUTH_LOGIN',
              appid: APPID,
              GDSSID: GDSSID,
              source: 1,
              PHPSESSIONID: PHPSESSID,
              extendInfo: JSON.stringify(_objectSpread({
                publicAppId: sourceInfo.weChatAppId,
                publicOpenId: wxUserInfo ? wxUserInfo.openId : openid,
                // 是否需要根据unionId登录 false:不需要 true:需要。默认true
                unionIdLogin: false
              }, wxUserInfo ? {
                unionId: wxUserInfo.unionId || '',
                nickName: wxUserInfo.nickname || '',
                picture: wxUserInfo.headImgUrl || ''
              } : null))
            }; // 设置基础内容
            setCookie(WX_USER_DATA, _objectSpread({
              UserId: 0,
              WxAppId: sourceInfo.weChatAppId,
              WxOpenid: wxUserInfo ? wxUserInfo.openId : openid
            }, wxUserInfo ? {
              UnionId: wxUserInfo.unionId || '',
              Nickname: wxUserInfo.nickname || '',
              PictureUrl: wxUserInfo.headImgUrl || ''
            } : null));
            _context5.next = 21;
            return LoginByOtherType(json2formdata(params));
          case 21:
            data = _context5.sent;
            status = data.status, result = data.result, info = data.info; // 登录成功
            if (!status) {
              // userDate 存在
              if (result && result.UserData) {
                currentWxUserInfo = getCurrentWeappWxData(result.UserData, sourceInfo.weChatAppId);
                !!currentWxUserInfo && setCookie(WX_USER_DATA, currentWxUserInfo);
                sensorsLogin(result.UserData.StudentId);
              }
              setUserLoginInfo(data);
              resolve(data);
            } else {
              reject(info);
            }
          case 24:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[8, 14]]);
    }));
    return function (_x7, _x8) {
      return _ref5.apply(this, arguments);
    };
  }());
};

/**
 * 检查当前登录状态
 */
export var checkLoginStatus = function checkLoginStatus(localToken) {
  return new Promise(function (resolve, reject) {
    // 有token
    if (localToken) {
      // 检查token是否有效
      checkToken(localToken).then(function (token) {
        resolve(token);
      }).catch(function (e) {
        reject(e);
      });
    } else {
      reject('未登录');
    }
  });
};

/**
 * 检查个人登录后是企业微信还是个人微信
 */
export var checkWxStatus = function checkWxStatus() {
  return new Promise(/*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(resolve, reject) {
      var _yield$switchWxStatus, result, status;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return switchWxStatus();
          case 2:
            _yield$switchWxStatus = _context6.sent;
            result = _yield$switchWxStatus.result;
            status = _yield$switchWxStatus.status;
            LStorage.set(WX_TYPE, result ? '1' : '0');
          // unbindingwx(qs.stringify(params)).then((data: any) => {
          //     if(!data.status) {
          //         let wxUserInfo = getCookie(getEnvStr(WX_USER_DATA));
          //         wxUserInfo["UserId"] = 0;
          //         setCookie(getEnvStr(WX_USER_DATA), wxUserInfo);
          //         resolve('解绑成功')
          //     }else {
          //         reject(data.info)
          //     }
          // })
          case 6:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x9, _x10) {
      return _ref6.apply(this, arguments);
    };
  }());
};

/**
 * 通过验证码登录并绑定公众号
 * @param phone 手机号
 * @param areaCode 手机号
 * @param code 验证码
 * @param name 姓名
 */
export var loginByVerifyAndBind = function loginByVerifyAndBind(phone, areaCode, code) {
  var name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return new Promise(/*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(resolve, reject) {
      var GDSSID, PHPSESSID, wxUserInfo, sourceInfo, params, data, status, result, info, currentWxUserInfo;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return getGDSSID();
          case 2:
            GDSSID = _context7.sent;
            PHPSESSID = getCookie('PHPSESSID') || GDSSID;
            wxUserInfo = getCookie(WX_USER_DATA) || {};
            _context7.next = 7;
            return getSourceInfo();
          case 7:
            sourceInfo = _context7.sent;
            params = {
              code: code.replace(/\s/g, ''),
              appid: APPID,
              GDSSID: GDSSID,
              source: '1',
              PHPSESSIONID: PHPSESSID,
              phone: phone.replace(/\s/g, ''),
              areaCode: areaCode,
              ucNickName: name,
              openId: wxUserInfo.WxOpenid,
              wxAppId: wxUserInfo.WxAppId,
              unionId: wxUserInfo.UnionId || '',
              weChatNickName: wxUserInfo.Nickname || '',
              weChatPictureUrl: wxUserInfo.PictureUrl || '',
              userId: 0,
              channel: sourceInfo['channelId'] || '',
              project: sourceInfo['projectId'] || ''
            };
            _context7.next = 11;
            return loginAndBind(json2formdata(params));
          case 11:
            data = _context7.sent;
            status = data.status, result = data.result, info = data.info; // 重复登录
            if (!(status === 1610614632)) {
              _context7.next = 16;
              break;
            }
            resolve();
            return _context7.abrupt("return");
          case 16:
            // 登录成功
            if (!status) {
              // userDate 存在
              if (result && result.UserData) {
                currentWxUserInfo = getCurrentWeappWxData(result.UserData, sourceInfo.weChatAppId);
                !!currentWxUserInfo && setCookie(WX_USER_DATA, currentWxUserInfo);
                sensorsLogin(result.UserData.StudentId);
              }
              setUserLoginInfo(data);
              checkWxStatus();
              resolve(data);
            } else {
              reject(info);
            }
          case 17:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x11, _x12) {
      return _ref7.apply(this, arguments);
    };
  }());
};

/**
 * 通过验证码登录
 * @param phone 手机号
 * @param code 验证码
 * @param name 姓名
 */
export var loginByVerify = function loginByVerify(phone, code) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return new Promise(/*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(resolve, reject) {
      var GDSSID, PHPSESSID, sourceInfo, params, data, status, result, info;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return getGDSSID();
          case 2:
            GDSSID = _context8.sent;
            PHPSESSID = getCookie('PHPSESSID') || GDSSID;
            _context8.next = 6;
            return getSourceInfo();
          case 6:
            sourceInfo = _context8.sent;
            params = {
              phone: phone.replace(/\s/g, ''),
              code: code.replace(/\s/g, ''),
              ucNickName: name,
              appid: APPID,
              GDSSID: GDSSID,
              PHPSESSIONID: PHPSESSID,
              channel: sourceInfo['channelId'] || '',
              project: sourceInfo['projectId'] || ''
            };
            _context8.next = 10;
            return loginByCode(qs.stringify(params));
          case 10:
            data = _context8.sent;
            status = data.status, result = data.result, info = data.info; // 登录成功
            if (!status) {
              setUserLoginInfo(data);
              sensorsLogin(result.UserData ? result.UserData.StudentId : '');
              checkWxStatus();
              resolve(data);
            } else {
              reject(info);
            }
          case 13:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x13, _x14) {
      return _ref8.apply(this, arguments);
    };
  }());
};

/**
 * 海外手机号通过验证码登录
 * @param phone 手机号
 * @param areaCode 手机号
 * @param code 验证码
 * @param name 姓名
 */
export var overseasLoginByVerify = function overseasLoginByVerify(phone, areaCode, code) {
  var name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return new Promise(/*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(resolve, reject) {
      var GDSSID, PHPSESSID, sourceInfo, params, data, status, result, info;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return getGDSSID();
          case 2:
            GDSSID = _context9.sent;
            PHPSESSID = getCookie('PHPSESSID') || GDSSID;
            _context9.next = 6;
            return getSourceInfo();
          case 6:
            sourceInfo = _context9.sent;
            params = {
              loginType: 'OVERSEAS_PHONE_LOGIN',
              appid: APPID,
              GDSSID: GDSSID,
              source: 1,
              PHPSESSIONID: PHPSESSID,
              extendInfo: JSON.stringify({
                overseasPhone: phone.replace(/\s/g, ''),
                code: code.replace(/\s/g, ''),
                areaCode: areaCode,
                ucNickName: name,
                channel: sourceInfo['channelId'] || '',
                project: sourceInfo['projectId'] || ''
              })
            };
            _context9.next = 10;
            return LoginByOtherType(json2formdata(params));
          case 10:
            data = _context9.sent;
            status = data.status, result = data.result, info = data.info; // 登录成功
            if (!status) {
              setUserLoginInfo(data);
              sensorsLogin(result.UserData ? result.UserData.StudentId : '');
              checkWxStatus();
              resolve(data);
            } else {
              reject(info);
            }
          case 13:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function (_x15, _x16) {
      return _ref9.apply(this, arguments);
    };
  }());
};

/**
 * 区分不同环境调用不同的登录接口
 */
export var diffEnvLoginByVerify = function diffEnvLoginByVerify(phone, area, verify, name) {
  var _window2, _window3;
  // 获取微信授权信息
  var wxUserInfo = getCookie(WX_USER_DATA);
  // 微信环境 && 已授权
  if ((_window2 = window) !== null && _window2 !== void 0 && (_window3 = _window2['browser']) !== null && _window3 !== void 0 && _window3.iswx && !!wxUserInfo) {
    return loginByVerifyAndBind(phone, area, verify, name);
  }
  return !area ? loginByVerify(phone, verify, name) : overseasLoginByVerify(phone, area, verify, name);
};